module.exports = __webpack_public_path__ + "static/img/13.97b2dd4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/1/zh/13.png
// module id = Cf6a
// module chunks = 0